import React from 'react'

import invisibleIcon from '../../assets/icons/invisible.svg'
import visibleIcon from '../../assets/icons/visible.svg'

import Button from '../button'
import Icon from '../icon'
import InputField from '../input-field'

type Props = Omit<
  React.ComponentProps<typeof InputField>,
  'action' | 'type' | 'mixedLabel' | 'mixed'
>

const PasswordInputField = (props: Props) => {
  const [passwordVisible, setPasswordVisible] = React.useState(false)

  return (
    <InputField
      {...props}
      type={passwordVisible ? 'text' : 'password'}
      action={
        <Button
          hierarchy="ghost-input-action"
          icon={
            passwordVisible ? (
              <Icon block source={invisibleIcon} />
            ) : (
              <Icon block source={visibleIcon} />
            )
          }
          size={props.size}
          onClick={() => setPasswordVisible(!passwordVisible)}
          disabled={props.disabled}
        />
      }
    />
  )
}

export default PasswordInputField
